// extracted by mini-css-extract-plugin
module.exports = {"root":"MoreMenu_root__2U0Rt","row":"MoreMenu_row__ASKU0"};